export const DEFAULT_INACTIVITY_TIMEOUT_MS = 15 * 60 * 1000;
export const DEFAULT_INACTIVITY_WARNING_MS = 2 * 60 * 1000;

const parsePositiveMs = (value, fallback) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return fallback;
  }
  return parsed;
};

export const getSessionTimeoutConfig = (env = process.env) => ({
  timeoutMs: parsePositiveMs(
    env.REACT_APP_INACTIVITY_TIMEOUT_MS,
    DEFAULT_INACTIVITY_TIMEOUT_MS
  ),
  warningMs: parsePositiveMs(
    env.REACT_APP_INACTIVITY_WARNING_MS,
    DEFAULT_INACTIVITY_WARNING_MS
  ),
});
